<lipp-info-page
  [isLoading]="isLoading"
  [icon]="icon"
  [title]="title"
  [description]="description"
></lipp-info-page>
